import { ROUTE_PATH } from "@/constants/routeConstants";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Index from "./Index";
import PublicRoute from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";
import LoginForm from "@/pages/Login/LoginForm";
import Dashboard from "@/components/Dashboard";
import EditLayout from "@/components/EditLayout";
import NotFoundPage from "@/pages/ValidationPages/NotFoundPage";
import AccountInactive from "@/pages/ValidationPages/AccountInactive";
import { AuthRedirectHandler } from "@/components/auth/AuthRedirectHandler";
import UserStatusGuard from "@/components/common/UserStatusGuard";
import { SessionTimeoutWarning } from "@/components/common/SessionTimeoutWarning";

const AppRouter = () => {
  return (
    <BrowserRouter>
      {/* Handle OAuth redirects and clean URL */}
      <AuthRedirectHandler />

      {/* HIPAA Compliance: Session timeout warning */}
      <SessionTimeoutWarning />

      <Routes>
        <Route path='/' element={<Index />} />
        <Route
          path={ROUTE_PATH.ROUTE_LOGIN}
          element={
            <PublicRoute>
              <LoginForm />
            </PublicRoute>
          }
        />
        
        {/* Account Inactive Page - Accessible to authenticated users */}
        <Route
          path={ROUTE_PATH.ROUTE_ACCOUNT_INACTIVE}
          element={
            <ProtectedRoute>
              <AccountInactive />
            </ProtectedRoute>
          }
        />
        
        {/* Protected Dashboard Routes - Requires active account */}
        <Route
          path={ROUTE_PATH.ROUTE_DASHBOARD}
          element={
            <ProtectedRoute>
              <UserStatusGuard>
                <Dashboard />
              </UserStatusGuard>
            </ProtectedRoute>
          }
        />
        <Route
          path={`${ROUTE_PATH.ROUTE_DASHBOARD}/:selectedItem`}
          element={
            <ProtectedRoute>
              <UserStatusGuard>
                <Dashboard />
              </UserStatusGuard>
            </ProtectedRoute>
          }
        />
        
        <Route
          path={ROUTE_PATH.ROUTE_EDIT_LAYOUT}
          element={
            <ProtectedRoute>
              <UserStatusGuard>
                <EditLayout />
              </UserStatusGuard>
            </ProtectedRoute>
          }
        />

        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
